import * as React from 'react';
import { useContext } from 'react';
import { useTheme } from '../../../../theme';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BaggagePriceBlock from '../BaggagePriceBlock/BaggagePriceBlock';
import { getDisabled, getPrice, getSelectedServices, hasUnconfirmedServices } from '../../store/selector';
import { BaggageContext } from '../../../context';
import { BaseButton } from '../../../../BaseComponents';
import { getBaggageHasChanges } from '../../utils';
import { SelectedUpgrade } from '../../types';
import { useConfig } from '../../../../context';

interface Props {
	initialSelectedServices: SelectedUpgrade[];
	onCancel: React.DispatchWithoutAction;
	onConfirm: React.DispatchWithoutAction;
}

const BaggageFooter: React.FC<Props> = ({ onConfirm, onCancel, initialSelectedServices }) => {
	const theme = useTheme('UpgradeBaggageDialog').BaggageFooter;
	const isReadOnly = useContext(BaggageContext)?.isReadOnly || false;
	const { t } = useTranslation('IncludedBaggage');

	const { dynamicBaggagePricing } = useConfig().global;

	const selectedServices = useSelector(getSelectedServices);
	const disabled = useSelector(getDisabled);
	const price = useSelector(getPrice);
	const unconfirmedServicesExists = useSelector(hasUnconfirmedServices);

	const hasChanges = dynamicBaggagePricing ? true : getBaggageHasChanges(initialSelectedServices, selectedServices);

	return (
		<div className={theme.root}>
			<div className={theme.row}>
				{price && <BaggagePriceBlock price={price} hideClear={isReadOnly || !unconfirmedServicesExists} />}

				<div className={theme.buttons_row}>
					<BaseButton variant="smallSecondary" className={theme.cancel_btn} onClick={onCancel}>
						{t('Cancel')}
					</BaseButton>
					{!isReadOnly && (
						<BaseButton
							variant="smallPrimary"
							className={theme.confirm_btn}
							onClick={onConfirm}
							disabled={!hasChanges || disabled}
						>
							{t('Confirm')}
						</BaseButton>
					)}
				</div>
			</div>
		</div>
	);
};

export default BaggageFooter;
